import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import PageAvatarInfo from "../../../components/UI/Avatar/PageAvatarInfo/PageAvatarInfo";
import CustomMenu from "../../../components/UI/Menus/CustomMenu/CustomMenu";
import CustomTabs from "../../../components/UI/Tabs/CustomTabs/CustomTabs";
import { MenuItemEntity } from "../../../entities/UIEntities/MenuItem";
import { TabItemEntity } from "../../../entities/UIEntities/TabItem";
import { MENU_ITEMS, ROLES_NAMES, SCOPE_TYPE } from "../../../enums/Enums";
import GmtService from "../../../hooks/useGmtService";
import Icons from "../../../resources/icons/Icons";
import Strings from "../../../resources/Strings";
import {
  handleDeleteUser,
  handleEditGmtDetails,
  handleEditChargeAccountDetails,
  handlePermissionActivation,
  handleUserPermissions,
  handleDeleteChargeAccountUser,
} from "../../../utils/MenuUtils";
import classes from "./ParkerInfo.module.css";

const GmtInfo = (props) => {
  const { getGmtDetails } = GmtService();
  let tabs = [];
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  
  // only if all the permissions in every scope is Inactive - display 'activate user'
  // and the list to show will be changed accordingly by active / disactive & project (empty list) / non-proejct
  const isActivateUserMenuItem = props?.userScopes?.every(us => us?.role?.name === 'Inactive');
  const isNonProject = selectedScope.type !== SCOPE_TYPE.PROJECT;
  const isChargeAccount = props.userScopes.some(us => us.role?.name === ROLES_NAMES.CHARGE_ACCOUNT);
  const fullName = isChargeAccount ? `${props?.utronUser?.chargeAccount?.name}` : `${props?.utronUser?.firstName} ${props?.utronUser?.lastName}`;

  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.EDIT_PROFILE,
      isChargeAccount ? handleEditChargeAccountDetails : handleEditGmtDetails,
      true,
      Icons.EDIT_ITEM,
      false,
      props
    ),
    new MenuItemEntity(
      isActivateUserMenuItem ? MENU_ITEMS.ACTIVE_USER : MENU_ITEMS.DISACTIVE_USER, // menuItemActivationText
      handlePermissionActivation,
      true,
      isActivateUserMenuItem ? Icons.MY_PROFILE : Icons.DISACTIVE_ITEM, // Icon
      false,
      {...props, isActivateUserMenuItem, isNonProject, selectedScope} // adding data to props to pass on
    ),
    new MenuItemEntity(
      MENU_ITEMS.PERMISSIONS,
      handleUserPermissions,
      true,
      Icons.PERMISSIONS,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.DELETE_USER,
      isChargeAccount ? handleDeleteChargeAccountUser : handleDeleteUser,
      false,
      Icons.DELETE_ITEM,
      true,
      props?.utronUser
    ),
  ].filter(item => isChargeAccount ? item.name !== MENU_ITEMS.PERMISSIONS && item.name !== MENU_ITEMS.DISACTIVE_USER : item);

  const detailsTab = new TabItemEntity(
    Strings.TABS_NAMES.DEATILS,
    Strings.TABS_NAMES.DEATILS,
    getGmtDetails({...props, isChargeAccount}) // (props)
  );

  // const activityTab = new TabItemEntity(
  //   Strings.TABS_NAMES.ACTIVITY,
  //   Strings.TABS_NAMES.ACTIVITY,
  //   getGmtActivity(props)
  // );

  tabs.push(detailsTab);
  //tabs.push(activityTab);

  const onTabChange = () => {};

  const handleClose = () => {
    props.handleCloseEvent();
  };

  return (
    <div className={classes.parkerInfo}>
      <IconButton
        className={classes.closeButton}
        aria-label="closeIcon"
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <div className={classes.parkerInfoHeader}>
        <PageAvatarInfo
          name={fullName}
          image={props?.utronUser?.image}
          sizeClass="big"
          hasAppBadge={props.app}
        ></PageAvatarInfo>
        {props.validRole && <CustomMenu menuItems={menuItems}></CustomMenu>}
      </div>
      <CustomTabs
        initialTab={Strings.TABS_NAMES.DEATILS}
        onTabChange={onTabChange}
        tabs={tabs}
      ></CustomTabs>
    </div>
  );
};

export default GmtInfo;
